import { Box, Tooltip } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { clone, debounce, each } from 'lodash';
import * as React from 'react';
import Select, { components } from 'react-select';

interface DropdownItem {
    key: string;
    value: string;
}

interface Props {
    ignorePosition?: boolean;
    size?: string;
    placeholder?: string;
    disabled?: boolean;
    selected?: any;
    style?: any;
    items: DropdownItem[];
    onChange?: any;
    className?: string;
    menuWidth?: string;
    controllerWidth?: string;
    maxMenuHeight?: string;
    renderOverFixedObject?: boolean;
    floatRight?: boolean;
    customTopForFixedObject?: string;
    positionWrapper?: boolean;
    tooltip?: string;
    inputComponent?: any;
    selectWillClose?: boolean;
    isMenuOpen?: boolean;
    v3Position?: boolean;
    theme?:Theme;
}

interface State {
    selected: any;
    isMenuOpen: boolean;
}

export class DropdownV2 extends React.Component<Props, State> {

    state: State = {
        selected: this.props.selected ? this.props.selected : undefined,
        // selected: undefined,
        isMenuOpen: false,
    }

    componentDidMount() {
        this.calculatedGivenValue();

        if (this.props.isMenuOpen === true) {
            this.setState({
                isMenuOpen: true
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (!(prevProps.selected === this.props.selected)) {
            if (this.props.selected === undefined) {
                this.setState({
                    selected: undefined
                });
            } else {
                this.calculatedGivenValue();
            }
        }
    }
    

    calculatedGivenValue = () => {
        const { selected } = this.props;
    
        if (selected !== undefined && selected !== null) {
            let selectedFromProps = clone(selected);
    
            if (selected.value === undefined) {
                let valueFromProps = undefined;
    
                each(this.props?.items, item => {
                    if (item?.key === selectedFromProps) {
                        valueFromProps = item?.value;
                    }
                });
    
                selectedFromProps = {
                    value: valueFromProps,
                    key: selected
                };
            }
    
            this.setState({
                selected: {
                    label: selectedFromProps.value,
                    value: selectedFromProps.key
                }
            });
        } else {
            this.setState({ selected: undefined });
        }
    }
    

    calculateStyleProvider = (provided, state) => {
        const { theme } = this.props;
        return {
            ...provided,
            color: state.isSelected ? 'white' : 'black',
            backgroundColor: state.isSelected ? theme?.custom?.mainButtonHighlight : 'white',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme?.custom?.hoverOptionColor,
                color: state.isSelected ? theme?.custom?.mainButtonHighlight : 'inherit',
            }
        }
    }

    calculateControlProvider = (provided, state) => {
        const {
            controllerWidth
        } = this.props;
        const { theme } = this.props;


        if (controllerWidth === undefined) {
            return {
                ...provided,
                ':hover': {
                    border: `1px solid ${theme?.custom?.mainButtonHighlight}`,
                    color: theme?.custom?.mainButtonHighlight
                },
            };
        }
        else {
            return {
                ...provided,
                width: `${controllerWidth} !important`,
                ':hover': {
                    border: `1px solid ${theme?.custom?.mainButtonHighlight}`,
                    color: theme?.custom?.mainButtonHighlight
                },
            }
        }
    }

    calculateMenuProvider = (provided, state) => {
        const {
            menuWidth,
            renderOverFixedObject,
            customTopForFixedObject,
        } = this.props;
        const { theme } = this.props;
        if (menuWidth !== undefined && renderOverFixedObject !== true) {
            return {
                ...provided,
                position: 'absolute',
                zIndex: theme?.custom?.menuZIndex,
                width: menuWidth,
                overflow: 'hidden',
                margin: "2px 0 0",
            }
        }

        if (renderOverFixedObject === true) {
            if (menuWidth !== undefined) {
                return {
                    ...provided,
                    zIndex: theme?.custom?.menuZIndex,
                    position: 'fixed',
                    marginTop: '-75px',
                    overflow: 'hidden',
                    margin: "2px 0 0",
                }
            }
            else {
                if (customTopForFixedObject === undefined) {
                    return {
                        ...provided,
                        zIndex: theme?.custom?.menuZIndex,
                        position: 'fixed',
                        marginTop: '-75px',
                        width: menuWidth,
                        overflow: 'hidden',
                        margin: "2px 0 0",
                    }
                }
                else {
                    return {
                        ...provided,
                        zIndex: theme?.custom?.menuZIndex,
                        position: 'fixed',
                        marginTop: customTopForFixedObject,
                        width: menuWidth,
                        overflow: 'hidden',
                        margin: "2px 0 0",
                    }
                }
            }
        }

        return {
            ...provided,
            zIndex: theme?.custom?.menuZIndex,
            backgroundColor: 'white',
            overflow: 'hidden',
            margin: "2px 0 0",
        }
    }

    calculateDropdownArrowProvider = (provided, state) => {
        const { theme } = this.props;
        return {
            ...provided,
            color: '#cccccc',
            ':hover': {
                color: theme?.custom?.mainButtonHighlight,
            },
        }
    }

    calculateMenuPortalStyle = (baseStyle, state) => {
        const { theme } = this.props;
        return {
        ...baseStyle,
        zIndex: theme?.custom?.menuInsideModalZIndex,
    }
    }

    buildPeriodItems = () => {
        const {
            items
        } = this.props;

        let convertedFormat = [];

        each(items, item => {
            convertedFormat.push(
                {
                    label: item.value,
                    value: item.key
                }
            );
        })

        return convertedFormat;
    }

    openDropdown = () => {
        this.setState({ isMenuOpen: true });
    }
    // Interface for "getting" a value
    // similar to the old teacup component
    public getValue = () => {
        const {
            selected
        } = this.state;

        if (selected === undefined) {
            return undefined;
        }

        return {
            key: selected.value,
            value: selected.label
        };
    }

    public getValueSubValue = () => {
        const source = this.getValue();

        if (source === undefined) {
            return undefined;
        }

        return source.key;
    }

    renderWrapper = (core: JSX.Element) => {
        return core;
    }

    renderControl = (props) => {
        return (
            <Tooltip title={this.props?.tooltip ? this.props?.tooltip : ''} sx={{}}>
                <span onClick={() => this.setState(prev => ({ isMenuOpen: !prev.isMenuOpen }))}>
                    <components.Control {...props} ></components.Control>
                </span>
            </Tooltip>
        )
    }

    reportValueChangeDebounced = debounce((data) => {
        if (this.props.onChange) {
            if (data !== undefined) {
                this.props.onChange(undefined, data);
            }
        }
    }, 5);

    render() {
        const {
            className,
            floatRight,
            inputComponent
        } = this.props;

        const {
            selected
        } = this.state;

        const styleProvider = {
            option: this.calculateStyleProvider,
            control: this.calculateControlProvider,
            menu: this.calculateMenuProvider,
            dropdownIndicator: this.calculateDropdownArrowProvider,
            menuPortal: this.calculateMenuPortalStyle,
        };

        let decidedClassName = className ? 'react-select-dd ' + className : 'react-select-dd';

        if (floatRight === true) {
            decidedClassName += ' react-select-dd-floatright'
        }

        const dropdownOptions = this.buildPeriodItems();

        if (inputComponent === undefined) {
            return this.renderWrapper(
                    <Select
                            value={selected || null}
                            closeMenuOnSelect={this.props.selectWillClose ? this.props.selectWillClose : null}
                            onMenuClose={() => this.setState({ isMenuOpen: false })}
                            menuIsOpen={this.state.isMenuOpen}
                            components={{ Control: this.renderControl }}
                            className={decidedClassName}
                            styles={styleProvider}
                            options={clone(dropdownOptions)}
                            openMenuOnFocus={true}
                            placeholder={this.props?.placeholder}
                            isDisabled={this.props?.disabled}
                            onChange={(options: any) => {
                                this.setState({
                                    selected: options
                                });

                                const newValue = options.value;

                                this.reportValueChangeDebounced(newValue);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                    />
            )
        }
        else {
            return <Box>debug</Box>
        }
    }
}
